import { useEffect, useState } from 'react';
import { notification, Button, Col, Form, Input, Modal, Row, Select } from 'antd';
import { DOB_YEAR_LIST, GENDER_LIST } from '../../../data';
import ApiService from '../../../services/ApiService';
import DataService from '../../../services/DataService';

export const SimulationNewStudentModal = ({ simulationId, simulationCountries, student, onClose, onSave }) => {
  const [api, contextHolder] = notification.useNotification();
  const [form] = Form.useForm();
  const [isSubmitting, setSubmitting] = useState(false);

  const countryList = DataService.getItem('countryList');

  const onFinish = async values => {
    setSubmitting(true);
    try {
      const payload = { ...values, primaryLanguageId: 1 };
      await ApiService.addSimulationCountryStudent(simulationId, payload);
      onSave();
    } catch (e) {
      api.open({
        message: 'Sorry...',
        description: 'Something went wrong...',
      });
    }
    setSubmitting(false);
  };

  useEffect(() => {
    form.resetFields();
  }, [form, student]);

  return (
    <Modal
      title="Add Student"
      open={!!student}
      onCancel={onClose}
      footer={[
        <Button key="save" type="primary" loading={isSubmitting} onClick={() => form.submit()}>
          Add
        </Button>,
      ]}
    >
      {contextHolder}
      <Form layout="vertical" form={form} onFinish={onFinish} requiredMark={false} autoComplete="off">
        <Form.Item
          label="Username"
          name="userName"
          rules={[
            {
              required: true,
              message: 'Username is required!',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Password"
          name="password"
          rules={[
            {
              required: true,
              message: 'Password is required!',
            },
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="First Name"
              name="firstName"
              rules={[
                {
                  required: true,
                  message: 'First name is required!',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Last Name"
              name="lastName"
              rules={[
                {
                  required: true,
                  message: 'Last name is required!',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          label="Email"
          rules={[
            {
              required: true,
              message: 'Email is required!',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Gender"
          name="genderId"
          rules={[
            {
              required: true,
              message: 'Gender is required!',
            },
          ]}
        >
          <Select showSearch placeholder="Select gender" options={GENDER_LIST} />
        </Form.Item>
        <Form.Item
          label="Simulation Country"
          name="simulationCountryId"
          rules={[
            {
              required: true,
              message: 'Simulation Country is required!',
            },
          ]}
        >
          <Select
            showSearch
            placeholder="Select simulation country"
            optionFilterProp="countryName"
            fieldNames={{ label: 'countryName', value: 'simulationCountryId' }}
            options={simulationCountries}
          />
        </Form.Item>
        <Form.Item
          label="Home Country"
          name="countryId"
          rules={[
            {
              required: true,
              message: 'Home Country is required!',
            },
          ]}
        >
          <Select
            showSearch
            placeholder="Select home country"
            optionFilterProp="countryName"
            fieldNames={{ label: 'countryName', value: 'countryId' }}
            options={countryList}
          />
        </Form.Item>
        <Form.Item
          label="Year of Birth"
          name="yearOfBirth"
          rules={[
            {
              required: true,
              message: 'Year of Birth is required!',
            },
          ]}
        >
          <Select showSearch placeholder="Select year of birth" options={DOB_YEAR_LIST} />
        </Form.Item>
        <Form.Item label="Class Section" name="classSection">
          <Input />
        </Form.Item>
        <Form.Item className="d-none">
          <Button type="primary" htmlType="submit"></Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};
